import React, { useContext, useState, useRef, useEffect } from "react";
import ReactDOM from 'react-dom';
import { useTranslation } from "react-i18next";
import { Card } from "react-bootstrap"
import { IconButton } from "@fluentui/react";
import JqxGrid, { jqx } from 'jqwidgets-scripts/jqwidgets-react-tsx/jqxgrid';

import TemplateDoc from '../../../templates/sBook/Mantainers/tmp_BusinessUnits.csv'
import { useGetBusinessUnitsMaintainer, useGetListBusinessUnits } from "../../../hooks/services/sBook/useOfBusinessUnit";
import { addBusinessUnit, addBusinessUnitList, deleteBusinessUnit, getBusinessUnitById, saveBusinessUnitById } from "../../../services/sBook/businessUnit.service";
import { useGetLegalEntities } from "../../../hooks/services/sBook/useOfLegalEntity";
import { downloadCSV, getGridLocalization, isNullUndefinedOrEmpty, showMessage } from "../../../common/Helpers";
import ProfileVerify from "../../../components/Templates/Site/ProfileVerify";
import MessageBox from "../../../components/Common/Message/MessageBox";
import { __MessageTypes } from "../../../common/Dictionaries";
import { nullRender } from "@uifabric/experiments/lib/Utilities";
import MainAppContext from "../../../MainAppContext";
import MatrixToolbar from "../../../components/Products/sPrivilege/Matrix/MatrixToolbar";
import * as XLSX from 'xlsx';
import { applyFilters, executeScrollMovementToFixLockRowOnEditCell, handlerFilter, removeGridLocalStorageFilters, setterActionFired, useFilterActionComponentData } from "../../../common/Helpers/JqxGridFilter";
import 'jqwidgets-scripts/jqwidgets/styles/jqx.light.css';

export default function BusinessUnit(props) {
    const { t } = useTranslation();
    const contextSite = useContext(MainAppContext);
    const profileHasAccess = !contextSite.onlyObserver || (contextSite.securityProps.isSAdmin ||  contextSite.securityProps.isAdmin)

    const gridRef = useRef();
    const fileInputRef = useRef(null);

    const [showRequiredGlobalMessage, setShowRequiredGlobalMessage] = useState(false);
    const [editingRows, setEditingRows] = useState([]);

    const [messageConfig, setMessageConfig] = useState({
        message : null,
        messageType : "",
        showMessage : false,
    });

    const [listLegalEntities, setListLegalEntities] = useState(null);
    useGetLegalEntities(listLegalEntities, setListLegalEntities)

    const [listBusinessUnitParent, setListBusinessUnitParent] = useState(null);
    useGetListBusinessUnits(listBusinessUnitParent, setListBusinessUnitParent)

    const [listBusinessUnit, setListBusinessUnit] = useState(null);
    useGetBusinessUnitsMaintainer(listBusinessUnit, setListBusinessUnit);

    useFilterActionComponentData(gridRef, messageConfig, "BusinessUnit");

    useEffect(() => {
        if (listBusinessUnit === null) {
            removeGridLocalStorageFilters("BusinessUnit")
        }

    }, [listBusinessUnit]);


    const handlerAddNewRow = (obj) => {
        const _lowerId = listBusinessUnit.length !== 0 ? listBusinessUnit.reduce((min, obj) => obj.id < min ? obj.id : min, listBusinessUnit[0].id) : 0;
        const lowerId = listBusinessUnit.length === 0 ? -1 : (_lowerId > 0 ? ((_lowerId * -1) - 1) : _lowerId -1);

        const newRow = !obj ? {
            id:                   lowerId,
            name:                 "",
            businessUnitCode:     "",
            businessUnitParentId: null,
            legalEntityId:        null,
        } : {
            id:                   lowerId,
            name:                 obj.name,
            businessUnitCode:     obj.businessUnitCode,
            businessUnitParentId: obj.businessUnitParentId,
            legalEntityId:        obj.legalEntityId,
        };

        gridRef.current.beginupdate();
        gridRef.current.addrow(null, newRow, 'first');

        listBusinessUnit.unshift(newRow);
        setListBusinessUnit(listBusinessUnit);

        if (editingRows.length > 0 ? editingRows.find(x => x === lowerId) === undefined : true) {
            editingRows.push(lowerId)
            setEditingRows(editingRows);
        }

        gridRef.current.endupdate();
        gridRef.current.updatebounddata('rows');
        setterActionFired("BusinessUnit", 1)
    };

    const handlerUploadData = () => {
        fileInputRef.current.click();
    };

    const handlerFileUpload = (event) => {
        const file = event.target.files[0];
        const reader = new FileReader();

        reader.onload = (e) => {
            const data = new Uint8Array(e.target.result);
            const workbook = XLSX.read(data, { type: 'array' });
            const worksheet = workbook.Sheets[workbook.SheetNames[0]];
            const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

            const convertedData = jsonData.slice(1).map((row, rowIndex) => {
                const convertedRow = {};
                row.forEach((cell, columnIndex) => {
                    const columnName = getColumns().find(x => x.index === columnIndex).dataField;
                    convertedRow[columnName] = cell;
                });

                convertedRow.id = null;

                return convertedRow;
            });

            convertedData.forEach(element => {
                handlerAddNewRow(element)
            });
        };

        reader.readAsArrayBuffer(file);
        fileInputRef.current.value = '';
    };

    const getValue = (column, row) => {
        const itemValue = column.editorOptions.find(x => x.key === row[column.dataField])

        return !isNullUndefinedOrEmpty(itemValue) ? itemValue.text : "";
    }

    const handlerExportData = (exportData) => {
        const workbook = XLSX.utils.book_new();

        const aux_rows = []

        if (exportData) {
            const aux_list = listBusinessUnit.filter(x => x.id > 0);

            aux_list.forEach(row => {
                let aux_row = {};
                getColumns().forEach(column => {
                    if (column.exportable) {
                        if (column.columntype === 'dropdownlist') {
                            aux_row[column.dataField] = row[column.dataField] !== null ? getValue(column, row) : "";
                        }
                        else {
                            aux_row[column.dataField] = row[column.dataField];
                        }
                    }
                });
    
                aux_rows.push(aux_row);
            });
        }

        const worksheet = XLSX.utils.json_to_sheet(aux_rows, { header: getColumns().filter(x => (exportData ? x.exportable : x.uploadMasive)).map(column => column.dataField) });
        
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Data');

        if (exportData) {
            XLSX.writeFile(workbook, 'BusinessUnit_ExportedData.xlsx');
        }
        else {
            XLSX.writeFile(workbook, 'BusinessUnit_UploadTemplate.xlsx');
        }
    };

    const handlerSaveAll = () => {
        const aux_list = gridRef.current.props.source.records.filter(x => x.id <= 0);

        //Obtener todos los elementos con id 0, ya que estos son los elementos a agregar.
        //Validar cada elemento, que el name no este blanco.
        //Luego de enviar a guardar, los elementos que se devuelvan deben ser actualizados en el listado local.
        //Se deben gatillar los errores de los que no pudieron ser guardados.
        const new_list = [];

        aux_list.forEach(item => {
                new_list.push({
                id: item.id,
                legalEntityId: item.legalEntityId,
                legalEntityName: item.LegalEntity_Id,
                businessUnitParentId: item.businessUnitParentId,
                businessUnitParentName: item.BusinessUnitParent_Id,
                businessUnitNemo: "",
                businessUnitCode: item.businessUnitCode,
                name: item.name,
            })
        })

        addBusinessUnitList(new_list).then(() => {
            setListBusinessUnit(null);
            showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'))    
            setterActionFired("BusinessUnit", 1)
        }).catch(() => {
            showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
            setterActionFired("BusinessUnit", 1)
        });
    };

    const onGetTemplateClick = (type) => {
        const linkExport = document.getElementById("btnGetTemplateJson");
        let exportFileName = "";
        let excelStrData = "Id;Name\n";
        
        switch (type) {
            case "LE":
                exportFileName = t('data-lang-lbl-legalentity') + ".csv";
                listLegalEntities.forEach(element => {
                    excelStrData += element.key + ";" + element.title + "\n"
                });
                downloadCSV(excelStrData, "data:text/csv;charset=utf-8,%EF%BB%BF", linkExport, exportFileName);
                break;

            case "BU":
                exportFileName = t('data-lang-lbl-businessunit') + ".csv";
                listBusinessUnitParent.forEach(element => {
                    excelStrData += element.key + ";" + element.title + "\n"
                });
                downloadCSV(excelStrData, "data:text/csv;charset=utf-8,%EF%BB%BF", linkExport, exportFileName);
                break;

            case "Data":
                const btnGetTemplate = document.getElementById('btnGetTemplate');
                btnGetTemplate.click();
                break;
            default:
                break;
        }
    };

    const handlerSave = async (itemId) => {       
        const item = gridRef.current.props.source.records.find(x => x.id === itemId);

        if (validateObject(item)) {
            if (item.id <= 0) {

                const newItem = 
                {
                    id: item.id,
                    legalEntityId: item.legalEntityId,
                    legalEntityName: item.LegalEntity_Id,
                    businessUnitParentId: item.businessUnitParentId,
                    businessUnitParentName: item.BusinessUnitParent_Id,
                    businessUnitNemo: "",
                    businessUnitCode: item.businessUnitCode,
                    name: item.name,
                }

                await addBusinessUnit(newItem).then(async (serviceResponse) => {
                    if (serviceResponse.data.succeeded) {
                        setEditingRows(editingRows.filter(x => x !== item.id))

                        listBusinessUnit.forEach(element => {
                            if (element.id === parseInt(item.id)) {
                                element.id = serviceResponse.data.data.id;
                                element.businessUnitCode = serviceResponse.data.data.businessUnitCode;
                            }
                        });

                        setListBusinessUnit(listBusinessUnit);
                        showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'))
                    }
                    else {
                        showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                    }        
                    setterActionFired("BusinessUnit", 1)
                }).catch(() => {
                    showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                    setterActionFired("BusinessUnit", 1)
                });
            }
            else {
                saveBusinessUnitById(itemId, item).then(async (serviceResponse) => {
                    if (serviceResponse.data.succeeded) {
                        setEditingRows(editingRows.filter(x => x !== item.id))
                        showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'))
                    }
                    else {
                        showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                    }  
                    setterActionFired("BusinessUnit", 1)
                }).catch(() => {
                    showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                    setterActionFired("BusinessUnit", 1)
                });
            } 

            setShowRequiredGlobalMessage(false);
        }
        else {
            setShowRequiredGlobalMessage(true);
        }
    };

    const handlerDelete = async (itemId) => {
        if (itemId <= 0) {
            const newListBusinessUnit = listBusinessUnit.filter(x => x.id !== itemId);
            setListBusinessUnit(newListBusinessUnit)
            setEditingRows(editingRows.filter(x => x !== itemId));
            showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'))    
            setterActionFired("BusinessUnit", 1)
        }
        else {
            await deleteBusinessUnit(itemId).then(async (serviceResponse) => {
                if (serviceResponse.data.succeeded) {
                    const newListBusinessUnit = listBusinessUnit.filter(x => x.id !== itemId);
                    setListBusinessUnit(newListBusinessUnit)
                    setEditingRows(editingRows.filter(x => x !== itemId));

                    showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'))    
                }
                else {
                    showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                }
                setterActionFired("BusinessUnit", 1)
            }).catch(() => {
                showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                setterActionFired("BusinessUnit", 1)
            });
        }
    };

    const handlerCancel = async (itemId) => {
        if (itemId === null) {
            const newListBusinessUnit = listBusinessUnit.filter(x => x.id !== itemId);
            setListBusinessUnit(newListBusinessUnit)
            setEditingRows(editingRows.filter(x => x !== itemId));
            showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'))    
            setterActionFired("BusinessUnit", 1)
        }
        else
        {
            await getBusinessUnitById(itemId).then(async (serviceResponse) => {
                if (serviceResponse.data.succeeded) {
                    listBusinessUnit.forEach(element => {
                        if (serviceResponse.data.data.id === element.id) {
                            for (const property in serviceResponse.data.data) {
                                element[property] = serviceResponse.data.data[property]
                            }
                        }
                    });
            
                    setListBusinessUnit(listBusinessUnit);
                    setEditingRows(editingRows.filter(x => x !== itemId));
                    showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'))    
                }
                else {
                    showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                }
                setterActionFired("BusinessUnit", 1)
            }).catch(() => {
                showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                setterActionFired("BusinessUnit", 1)
            });
        }
    };

    const validateObject = (object) => {
        const isValid = object.name !== undefined && object.name !== null && object.name !== '';

        return isValid;
    };

    const getRowIdFromRowIndex = (rowIndex) => {
        if (typeof rowIndex === 'object' && rowIndex.boundindex !== undefined) {
            return listBusinessUnit[rowIndex.boundindex].id;
        }
        return listBusinessUnit[rowIndex]?.id;
    };

    const onCellvaluechanged = (e) => {
        const currentColumn = e.owner._columns.find(x => x.datafield === e.args.datafield);

        if (currentColumn.columntype === "dropdownlist") {
            listBusinessUnit[e.args.rowindex][e.args.datafield] = e.args.value.value
        }
        else {
            listBusinessUnit[e.args.rowindex][e.args.datafield] = e.args.value
        }

        const copia_listContracts = JSON.parse(JSON.stringify(listBusinessUnit));
        setListBusinessUnit(copia_listContracts);

        if (editingRows.find(x => x === listBusinessUnit[e.args.rowindex].id) === undefined) {
            editingRows.push(listBusinessUnit[e.args.rowindex].id)
        }

        setEditingRows(editingRows);
        applyFilters(gridRef, 'BusinessUnit', false);

        executeScrollMovementToFixLockRowOnEditCell(gridRef);
    };

    const actionCellsRenderer = (objSource) => {
        const itemId = getRowIdFromRowIndex(objSource)
        const isEditing = editingRows.find(x => x === itemId);
        const rowIndex = 0;
        return  <>
                {
                    profileHasAccess &&
                    <>
                        {isEditing ? (
                            <>
                                {
                                    itemId <= 0 ? (
                                        <>
                                            <IconButton iconProps={{ iconName: 'Save' }} title="Guardar" ariaLabel="Guardar" onClick={() => fieldActionHandler(itemId, 'save')} />
                                            <IconButton iconProps={{ iconName: 'Delete' }} title="Eliminar" ariaLabel="Eliminar" onClick={() => fieldActionHandler(itemId, 'delete')} />
                                        </>
                                    ) : (
                                        <>
                                            <IconButton iconProps={{ iconName: 'Save' }} title="Guardar" ariaLabel="Guardar" onClick={() => fieldActionHandler(itemId, 'save')} />
                                            <IconButton iconProps={{ iconName: 'Cancel' }} title="Cancelar" ariaLabel="Cancelar" onClick={() => fieldActionHandler(itemId, 'cancel')} />
                                            <IconButton iconProps={{ iconName: 'Delete' }} title="Eliminar" ariaLabel="Eliminar" onClick={() => fieldActionHandler(itemId, 'delete')} />
                                        </>
                                    )
                                }
                            </>
                        ) : (
                            <IconButton iconProps={{ iconName: 'Delete' }} title="Eliminar" ariaLabel="Eliminar" onClick={() => fieldActionHandler(itemId, 'delete')} />
                        )}
                    </>
                }
                </>
    };

    const fieldActionHandler = (itemId, actionType) => {
        switch (actionType) {
            case 'save':
                handlerSave(itemId)
                break;
            case 'delete':
                handlerDelete(itemId)
                break;
            case 'cancel':
                handlerCancel(itemId)
                break;
            default:
                break;
        }
    };

    const cellsRenderer = (rowIndex, cellValue, editor, cellText, width, height, auxListData, cellType, subType) => {
        switch (cellType) {
            case 'textbox':
                switch (subType) {
                    case "currency":
                        editor.jqxNumberInput({
                            decimalDigits: 3,
                            width: width,
                            spinButtons: false,
                            symbol: '$',
                            groupSeparator: ',',
                            decimalSeparator: '.',
                            digits: 19, 
                            max: 9999999999,
                        });
                        break;
                    case "number":
                        editor.jqxNumberInput({
                            decimalDigits: 3,
                            width: width,
                            spinButtons: true,
                            groupSeparator: ',',
                            decimalSeparator: '.',
                            digits: 19, 
                            max: 9999999999,
                        });
                        break;
                    default:
                        break;
                }
                break;
            case 'datetimeinput':
                break;
            case 'checkbox':
                editor.jqxCheckBox({ width: width });
                break;
                case 'dropdownlist':
                editor.jqxDropDownList({
                    width: width,
                    height: height,
                    source: getListColumnAdapter(auxListData, 'key', 'text'),
                    displayMember: 'text',
                    valueMember: 'key',
                    autoDropDownHeight: auxListData.length < 5
                });
            default:
                break;
        }
    };

    const cellRenderClassStyle = (row, columnfield, value, columnType) => {
        let className = "";
        switch (columnType) {
            case "textbox":
                if (value === '') {
                    className = 'jqx-custom-validation-red';
                }
                else {
                    className = '';
                }
                break;
            case "numberinput":
                if (value < 0 || value === '') {
                    className = 'jqx-custom-validation-red';
                }
                else {
                    className = '';
                }
                break;
            case "datetimeinput":
                if (value === '') {
                    className = 'jqx-custom-validation-red';
                }
                else {
                    className = '';
                }
                break;
            case "dropdownlist":
                if (value === null || value === '' || value === 0) {
                    className = 'jqx-custom-validation-red';
                }
                else {
                    className = '';
                }
                break
            default:
                break;
        }

        return className;
    };

    const getListColumnAdapter = (listObjetcs, key, text) => {
        return new jqx.dataAdapter({
            datafields: [
                { name: text, type: 'string' },
                { name: key, type: 'number' }
            ],
            datatype: 'array',
            localdata: listObjetcs
        }, { autoBind: true });
    };

    const getColumns = () => {
        const basicColumns = [
            { index: null, text: 'ID',                                  dataField: 'id',                   uploadMasive: false, exportable: false, width: '0px',   columntype: 'textbox', editable: false, hidden: true },
            { index: null, text: t('data-lang-lbl-actions'),            dataField: 'acciones',             uploadMasive: false, exportable: false, width: '5%', pinned: true,
                createwidget: (row, column, value, htmlElement) => { ReactDOM.render(actionCellsRenderer(row), htmlElement); },
                initwidget: (row, column, value, htmlElement) => { ReactDOM.render(actionCellsRenderer(row), htmlElement); },
            },
            { index: 0,    text: t('data-lang-lbl-code'),               dataField: 'businessUnitCode',     uploadMasive: true,  exportable: true,  width: '10%', createeditor: (rowIndex, cellValue, editor, cellText, width, height) =>  cellsRenderer(rowIndex, cellValue, editor, cellText, width, height, null,                   'textbox', 'string'), columntype: 'textbox',        cellclassname: (row, columnfield, value) => cellRenderClassStyle(row, columnfield, value, 'textbox'),       editable: profileHasAccess, pinned: true },
            { index: 1,    text: t('data-lang-lbl-legalentity'),        dataField: 'legalEntityId',        uploadMasive: true,  exportable: true,  width: '20%', createeditor: (rowIndex, cellValue, editor, cellText, width, height) =>  cellsRenderer(rowIndex, cellValue, editor, cellText, width, height, listLegalEntities,      'dropdownlist'),      columntype: 'dropdownlist',   cellclassname: (row, columnfield, value) => cellRenderClassStyle(row, columnfield, value, 'dropdownlist'),  editable: profileHasAccess, displayfield: 'LegalEntity_Id', editorOptions: listLegalEntities },
            { index: 2,    text: t('data-lang-lbl-name'),               dataField: 'name',                 uploadMasive: true,  exportable: true,  width: '45%', createeditor: (rowIndex, cellValue, editor, cellText, width, height) =>  cellsRenderer(rowIndex, cellValue, editor, cellText, width, height, null,                   'textbox', 'string'), columntype: 'textbox',        cellclassname: (row, columnfield, value) => cellRenderClassStyle(row, columnfield, value, 'textbox'),       editable: profileHasAccess, pinned: true },
            { index: 3,    text: t('data-lang-lbl-parentbusinessunit'), dataField: 'businessUnitParentId', uploadMasive: true,  exportable: true,  width: '20%',
                createeditor: (rowIndex, cellValue, editor, cellText, width, height) =>  {
                    const parentId = gridRef.current.getcellvalue(rowIndex, 'legalEntityId');

                    const subList = listBusinessUnitParent.filter(x => x.legalEntityId === parentId);

                    editor.jqxDropDownList({
                        width: width,
                        height: height,
                        source: getListColumnAdapter(subList, 'key', 'text'),
                        displayMember: 'text',
                        valueMember: 'key',
                        autoDropDownHeight: subList.length < 5
                    });
                },
                columntype: 'dropdownlist',
                cellclassname: (row, columnfield, value) => cellRenderClassStyle(row, columnfield, value, 'dropdownlist'),
                editable: profileHasAccess,
                displayfield: 'BusinessUnitParent_Id',
                editorOptions: listBusinessUnitParent
            },
        ]

        return basicColumns;
    };

    return (
        <div className="col-12 listWithActions h-100">
            <Card className="h-100">
                <Card.Header>
                    <Card.Title className="d-flex justify-content-between">
                        <h4><b>{t('data-lang-maintainer-title-businessunits')}</b></h4>
                    </Card.Title>
                </Card.Header>
                <Card.Footer>
                    <MessageBox
                        inputParam_Message={ messageConfig.message }
                        inputParam_Display={ messageConfig.showMessage }
                        inputParam_MessageType={ messageConfig.messageType }
                        inputParam_SetterMessage={ setMessageConfig }
                    />
                </Card.Footer>
                <Card.Body className="access-per-month-form-body h-100 overflow-hidden-deprecated">
                    <div className="align-items-center h-100">
                        <div className="d-none">
                            <input ref={fileInputRef} type="file" accept=".xlsx" onChange={handlerFileUpload} />
                            <a id="btnGetTemplate" href={TemplateDoc} download="ContractTemplate.csv" style={{display: "none"}} rel="noreferrer noopener" target='_blank'>#</a>
                            <a id="btnGetTemplateJson" href={undefined} download="Template.csv" style={{display: "none"}} rel="noreferrer noopener" target='_blank'>#</a>
                        </div>
                        {
                            listLegalEntities && listBusinessUnitParent && listBusinessUnit &&
                            <>
                                <MatrixToolbar
                                    inputParam_HandleSaveData={handlerSaveAll}
                                    inputParam_HandleUploadData={handlerUploadData}
                                    inputParam_HandleExportData={handlerExportData}
                                    inputParam_HandleAddRow={handlerAddNewRow}
                                    inputParam_Configuration={{
                                        buttons: {
                                            showRowButtons: profileHasAccess,
                                            showExportData: true,
                                            showAddMasiveData: profileHasAccess,
                                            showAddData: profileHasAccess,
                                            showDownloadTemplate: profileHasAccess,
                                            showSaveAllData: profileHasAccess,
                                            groupedButtons: profileHasAccess
                                        },
                                        handlers: {
                                            handlerSave: profileHasAccess ? handlerSave : null,
                                            handlerSaveAll: profileHasAccess ? handlerSaveAll : null,
                                            handlerDelete: profileHasAccess ? handlerDelete : null,
                                            handlerCancel: profileHasAccess ? handlerCancel : null,
                                        },
                                        auxiliarListCallbackOnAdd: null,
                                    }}
                                    inputParam_ExternalExportTemplates={[
                                        {
                                            id: 'btnMantGetTemplate',
                                            key: 'btnMantGetTemplate',
                                            text: t('data-lang-lbl-uploadtemplate'),
                                            iconProps: { iconName: 'ExcelDocument' },
                                            onClick: () => handlerExportData(false)
                                        },
                                        {
                                            id: 'btnMantGetTemplateLE',
                                            key: 'btnMantGetTemplateLE',
                                            text: t('data-lang-lbl-legalentity'),
                                            iconProps: { iconName: 'ExcelDocument' },
                                            onClick: () => onGetTemplateClick('LE')
                                        },
                                        {
                                            id: 'btnMantGetTemplateBU',
                                            key: 'btnMantGetTemplateBU',
                                            text: t('data-lang-lbl-businessunit'),
                                            iconProps: { iconName: 'ExcelDocument' },
                                            onClick: () => onGetTemplateClick('BU')
                                        }
                                    ]}
                                    inputParam_CustomOpenPanel={false}
                                    showRequiredMessage={showRequiredGlobalMessage}
                                />
                                <JqxGrid
                                    ref={gridRef}
                                    altrows={true}
                                    enabletooltips={true}
                                    width={'100%'}
                                    theme={'light'} 
                                    height={'500px'}
                                    editable={true}
                                    //pageable={true}
                                    sortable={true}
                                    filterable={true}
                                    showfilterrow={true} 
                                    localization={getGridLocalization(t)}
                                    source={new jqx.dataAdapter({
                                        localData: listBusinessUnit,
                                        dataType: 'array',
                                        dataFields: [
                                            { name: 'id',                   type: 'number' },
                                            { name: 'businessUnitCode',     type: 'string' },
                                            { name: 'name',                 type: 'string' },
                        
                                            { name: 'legalEntityId',        type: 'number' },
                                            { name: 'LegalEntity_Id', value: 'legalEntityId', values: { source: listLegalEntities, value: 'key', name: 'text' } },
                        
                                            { name: 'businessUnitParentId', type: 'number' },
                                            { name: 'BusinessUnitParent_Id', value: 'businessUnitParentId', values: { source: listBusinessUnitParent, value: 'key', name: 'text' } },
                                        ],
                                        id: 'id'
                                    })}
                                    columns={getColumns()}
                                    onCellvaluechanged={onCellvaluechanged} 
                                    onFilter={(event) => handlerFilter(event, 'BusinessUnit')}
                                />
                            </>
                        }
                    </div>
                </Card.Body>
            </Card>           
        </div>
    ); 
}